import dayjs from 'dayjs';

enum Months {
  Январь,
  Февраль,
  Март,
  Апрель,
  Май,
  Июнь,
  Июль,
  Август,
  Сентябрь,
  Октябрь,
  Ноябрь,
  Декабрь,
}

export const selectDate = (type, value, setInputValue, setResponseValue) => {
  switch (type) {
    case 'ГОД':
      console.log(value, value.view === 'century');
      if (value.view === 'century') {
        setInputValue(dayjs(value.value).format('YYYY'));
        const getYear = (value: Date) => {
          const dte = value;
          const y = dte?.getFullYear();
          console.log(value, y);
          return [
            dayjs(new Date(y, 0, 1)).format('YYYY-MM-DD'),
            dayjs(new Date(y, 11, 31)).format('YYYY-MM-DD'),
            dayjs(new Date(y - 1, 0, 1)).format('YYYY-MM-DD'),
            dayjs(new Date(y - 1, 11, 31)).format('YYYY-MM-DD'),
          ];
        };
        setResponseValue(getYear(value.value));
      } else if (value.constructor == Array) {
        setInputValue(dayjs(value[0]).format('YYYY'));
        const getYear = (value: Date) => {
          const dte = value[0];
          const y = dte?.getFullYear();
          return [
            dayjs(new Date(y, 0, 1)).format('YYYY-MM-DD'),
            dayjs(new Date(y, 11, 31)).format('YYYY-MM-DD'),
            dayjs(new Date(y - 1, 0, 1)).format('YYYY-MM-DD'),
            dayjs(new Date(y - 1, 11, 31)).format('YYYY-MM-DD'),
          ];
        };
        setResponseValue(getYear(value[0]));
      } else {
        setInputValue(dayjs(value).format('YYYY'));
        const getYear = (value: Date) => {
          const dte = value;
          const y = dte?.getFullYear();
          console.log(value, y);
          return [
            dayjs(new Date(y, 0, 1)).format('YYYY-MM-DD'),
            dayjs(new Date(y, 11, 31)).format('YYYY-MM-DD'),
            dayjs(new Date(y - 1, 0, 1)).format('YYYY-MM-DD'),
            dayjs(new Date(y - 1, 11, 31)).format('YYYY-MM-DD'),
          ];
        };
        setResponseValue(getYear(value));
      }
      break;
    case 'МЕСЯЦ':
      console.log(value);
      if (value.view === 'decade') {
        setInputValue(
          Months[(dayjs(value.value).format('M') as unknown as number) - 1] +
            ' ' +
            dayjs(value.value).format('YYYY'),
        );
        const getDaysOfMonth = (value: Date) => {
          const dte = value;
          const y = dte?.getFullYear();
          const m = dte?.getMonth();
          return [
            dayjs(new Date(y, m, 1)).format('YYYY-MM-DD'),
            dayjs(new Date(y, m + 1, 0)).format('YYYY-MM-DD'),
            dayjs(new Date(y, m - 1, 1)).format('YYYY-MM-DD'),
            dayjs(new Date(y, m, 0)).format('YYYY-MM-DD'),
          ];
        };
        setResponseValue(getDaysOfMonth(value.value));
      } else if (value.constructor == Array) {
        setInputValue(
          Months[(dayjs(value[0]).format('M') as unknown as number) - 1] +
            ' ' +
            dayjs(value[0]).format('YYYY'),
        );
        const getDaysOfMonth = (value: Date) => {
          const dte = value;
          const y = dte?.getFullYear();
          const m = dte?.getMonth();
          return [
            dayjs(new Date(y, m, 1)).format('YYYY-MM-DD'),
            dayjs(new Date(y, m + 1, 0)).format('YYYY-MM-DD'),
            dayjs(new Date(y, m - 1, 1)).format('YYYY-MM-DD'),
            dayjs(new Date(y, m, 0)).format('YYYY-MM-DD'),
          ];
        };
        setResponseValue(getDaysOfMonth(value[0]));
      } else {
        setInputValue(
          Months[(dayjs(value).format('M') as unknown as number) - 1] +
            ' ' +
            dayjs(value).format('YYYY'),
        );
        const getDaysOfMonth = (value: Date) => {
          const dte = value;
          const y = dte?.getFullYear();
          const m = dte?.getMonth();
          return [
            dayjs(new Date(y, m, 1)).format('YYYY-MM-DD'),
            dayjs(new Date(y, m + 1, 0)).format('YYYY-MM-DD'),
            dayjs(new Date(y, m - 1, 1)).format('YYYY-MM-DD'),
            dayjs(new Date(y, m, 0)).format('YYYY-MM-DD'),
          ];
        };
        setResponseValue(getDaysOfMonth(value));
      }
      break;
    case 'ПЕРИОД':
      setInputValue(dayjs(value[0]?.toDateString() ?? value).format('YYYY-MM-DD'));
      setResponseValue([
        dayjs(value[0]?.toDateString() ?? value).format('YYYY-MM-DD'),
        dayjs(value[1]?.toDateString() ?? value).format('YYYY-MM-DD'),
      ]);
      break;
    default:
      const getPrevDay = dayjs(value[0] ? (value[0] - 1).toString() : new Date(value - 1)).format(
        'YYYY-MM-DD',
      );
      setInputValue(dayjs(value[0]?.toDateString() ?? value).format('YYYY-MM-DD'));
      setResponseValue([
        dayjs(value[0]?.toDateString() ?? value).format('YYYY-MM-DD'),
        dayjs(value[0]?.toDateString() ?? value).format('YYYY-MM-DD'),
        getPrevDay,
        getPrevDay,
      ]);
  }
};
